import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-arrowsup",
  "use": "icon-arrowsup-usage",
  "viewBox": "0 0 9 13",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 9 13\" id=\"icon-arrowsup\">\r<path fill-rule=\"evenodd\" fill=\"rgb(220, 223, 230)\" d=\"M8.925,4.983 C8.925,5.200 8.585,5.417 8.360,5.417 L6.046,5.417 L6.046,12.618 C6.046,12.829 5.868,13.000 5.648,13.000 L3.349,13.000 C3.130,13.000 2.951,12.829 2.951,12.618 L2.951,5.417 L0.677,5.417 C0.338,5.417 0.112,5.200 -0.001,4.983 C-0.001,4.767 -0.001,4.442 0.224,4.225 L4.067,0.217 C4.179,0.108 4.293,0.000 4.519,0.000 C4.631,0.000 4.858,0.108 4.970,0.217 L8.812,4.225 C9.038,4.442 9.038,4.767 8.925,4.983 Z\" />\r</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/arrowsup.svg
// module id = ssSi
// module chunks = 127